import { connect } from 'react-redux'
import { changePassword } from './reducer'

const mapStateToProps = (state) => {
    return {
        email: state?.services?.user?.email,
    }
}

const mapDispatchToProps = { changePassword }

const hocChangeForgottenPassword = (InnerComponent) => connect(mapStateToProps, mapDispatchToProps)(InnerComponent)

export default hocChangeForgottenPassword
